<script>
import axios from 'axios';

import Layout from '../../layouts/auth';
import appConfig from '@/app.config';

import { required, email } from 'vuelidate/lib/validators';

/**
 * Forgot Password component
 */
export default {
	page: {
		title: 'Reset Password',
		meta: [
			{
				name: 'description',
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
	},
	data() {
		return {
			email: '',
			password: '',
			password_confirmation: '',
			token: '',
			submitted: false,
			error: null,
			tryingToReset: false,
			isResetError: false,
			isResetSuccess: false,
			success: null,
		};
	},
	validations: {
		email: {
			required,
			email,
		},
		password: {
			required,
		},
		password_confirmation: {
			required,
		},
	},
	mounted() {
		this.token = this.$route.query.token;
	},
	methods: {
		tryToReset() {
			this.submitted = true;
			// stop here if form is invalid
			this.$v.$touch();

			if (this.$v.$invalid) {
				return;
			} else {
				let config = {
					headers: {
						Accept: 'application/json',
					},
				};
				let data = {
					email: this.email,
					password: this.password,
					password_confirmation: this.password_confirmation,
					token: this.token,
				};
				axios.post('reset-password', data, config).then((res) => {
					console.log(res.data);
					if (res.data.status === false) {
						this.isResetError = true;
						this.error = res.data.message;
					} else {
						this.isResetSuccess = true;
						this.success = res.data.message;
					}

					// return res;
				});
			}
		},
	},
};
</script>

<template>
	<Layout>
		<div class="row justify-content-center">
			<div class="col-md-8 col-lg-6 col-xl-5">
				<div class="card overflow-hidden">
					<div class="bg-soft bg-primary">
						<div class="row">
							<div class="col-7">
								<div class="text-primary p-4">
									<h5 class="text-primary">Reset Password</h5>
									<p>Re-Password with MNTC.</p>
								</div>
							</div>
							<div class="col-5 align-self-end">
								<img src="@/assets/images/profile-img.png" alt class="img-fluid" />
							</div>
						</div>
					</div>
					<div class="card-body pt-0">
						<div>
							<router-link tag="a" to="/">
								<div class="avatar-md profile-user-wid mb-4">
									<span class="avatar-title rounded-circle bg-light">
										<img src="@/assets/images/logo.svg" alt height="34" />
									</span>
								</div>
							</router-link>
						</div>

						<div class="p-2">
							<div v-if="isResetError" class="alert alert-danger mb-4" role="alert">{{ error }}</div>

							<form @submit.prevent="tryToReset">
								<div class="mb-3">
									<label for="useremail">Email</label>
									<input type="email" v-model="email" class="form-control" id="useremail" placeholder="Enter email" :class="{ 'is-invalid': submitted && $v.email.$error }" />
									<div v-if="submitted && $v.email.$error" class="invalid-feedback">
										<span v-if="!$v.email.required">Email is required.</span>
										<span v-if="!$v.email.email">Please enter valid email.</span>
									</div>
								</div>

								<div class="mb-3">
									<label for="Password">Password</label>
									<input type="password" v-model="password" class="form-control" id="password" placeholder="Enter password" :class="{ 'is-invalid': submitted && $v.password.$error }" />
									<div v-if="submitted && $v.password.$error" class="invalid-feedback">
										<span v-if="!$v.password.required">password is required.</span>
									</div>
								</div>

								<div class="mb-3">
									<label for="password confirmation">Password Confirmation</label>
									<input type="password" v-model="password_confirmation" class="form-control" id="password_confirmation" placeholder="Password Confirmation" :class="{ 'is-invalid': submitted && $v.password_confirmation.$error }" />
									<div v-if="submitted && $v.password_confirmation.$error" class="invalid-feedback">
										<span v-if="!$v.password_confirmation.required">Password Confirmation is required.</span>
									</div>
								</div>

								<div class="mb-3 row mb-0" v-if="isResetSuccess == false">
									<div class="col-12 text-end">
										<button class="btn btn-primary w-md" type="submit">Reset</button>
									</div>
								</div>

								<div v-if="isResetSuccess" class="alert alert-success" role="alert">{{ success }}</div>
							</form>
						</div>
					</div>
					<!-- end card-body -->
				</div>
				<!-- end card -->

				<div class="mt-5 text-center">
					<p>
						Remember It ?
						<router-link tag="a" to="/login" class="fw-medium text-primary">Sign In here</router-link>
					</p>
					<p>© {{ new Date().getFullYear() }} MNTC.</p>
				</div>
			</div>
			<!-- end col -->
		</div>
		<!-- end row -->
	</Layout>
</template>

<style lang="scss" module></style>
